import React from "react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import BenefitsSection from "./components/BenefitsSection";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import OfertBannerSection from "./components/OfertBannerSection";
import PlansSection from "./components/PlansSection";
import { FaWhatsapp } from "react-icons/fa";

function App() {
  return (
    <div className="bg-[#0A0E12] text-white font-anton overflow-x-unset">
      <Navbar />
      <OfertBannerSection />
      <HeroSection id="inicio" />
      <BenefitsSection id="servicios" />
      <PlansSection id="planes" /> 
      <ContactForm id="contacto" />
      <Footer />

      {/* Botón flotante de WhatsApp */}
      <a
        href="https://wa.me/56940676501?text=Hola%2C%20me%20interesa%20sus%20servicios%20web"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 bg-[#25D366] hover:bg-[#1DA851] p-4 rounded-full shadow-lg z-50 transition-all"
      >
        <FaWhatsapp className="text-white text-2xl" />
      </a>
    </div>
  );
}

export default App;
